import React from "react";
import { Star, Bookmark, Share2, X, Eye, Pencil } from "lucide-react";
import formatCount from "../../utils/formatCount";
import MaterialCover from "./MaterialCover";

const ResourceSimpleItem = ({ item, isSaved, onOpen, onSave, onShare, onDismiss, onEdit }) => {
  return (
    <div 
      className="group flex items-center gap-4 p-3 rounded-xl hover:bg-muted border border-transparent hover:border-border transition-all cursor-pointer bg-card shadow-sm mb-2"
      onClick={() => onOpen(item.id)}
    >
      <div className="flex-shrink-0 relative w-[34px] h-[34px] rounded-lg overflow-hidden">
        <MaterialCover
          item={item}
          iconSize={18}
          fallbackClassName="bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300"
        />
      </div>
      
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-0.5">
          <h4 className="text-[13px] font-bold text-foreground truncate tracking-tight">{item.title}</h4>
          <span className="flex items-center gap-0.5 text-[10px] font-bold text-amber-500 bg-amber-500/10 px-1.5 py-0.5 rounded">
            <Star size={10} className="fill-current" /> {item.rating}
          </span>
        </div>
        <div className="flex items-center gap-2 text-[10px] text-muted-foreground font-medium">
          {item.pages ? <span>{item.pages} pages</span> : null}
          {item.readTime && item.readTime !== "N/A" && (
            <>
              {item.pages && <span className="w-1 h-1 rounded-full bg-border" />}
              <span>{item.readTime}</span>
            </>
          )}
          <span className="w-1 h-1 rounded-full bg-border" />
          <span className="flex items-center gap-1" title={`${item.views || 0} views`}>
            <Eye size={11} /> {formatCount(item.views)}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-1.5" onClick={(e) => e.stopPropagation()}>
        {onEdit && (
          <button
            onClick={() => onEdit(item.id)}
            title="Edit material"
            className="w-8 h-8 rounded-lg flex items-center justify-center transition-all bg-card text-muted-foreground border border-border hover:text-foreground hover:border-primary/50"
          >
            <Pencil size={14} />
          </button>
        )}
        <button
          onClick={() => onSave?.(item.id)}
          className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all ${
            isSaved ? "bg-primary text-primary-foreground" : "bg-card text-muted-foreground border border-border hover:text-foreground hover:border-primary/50"
          }`}
        >
          <Bookmark size={14} className={isSaved ? "fill-current" : ""} />
        </button>
        <button
          onClick={() => onShare?.(item.id)}
          className="w-8 h-8 rounded-lg flex items-center justify-center bg-card text-muted-foreground border border-border hover:text-foreground hover:border-primary/50 transition-all"
        >
          <Share2 size={14} />
        </button>
        {onDismiss && (
          <button
            onClick={() => onDismiss(item.id)}
            className="w-8 h-8 rounded-lg flex items-center justify-center bg-card text-muted-foreground border border-border hover:text-red-500 hover:border-destructive/20 hover:bg-destructive/10 transition-all"
          >
            <X size={14} />
          </button>
        )}
      </div>
    </div>
  );
};

export default ResourceSimpleItem;
